/**
 * @file Reads the scope labels the UI shows for each analytics scope level.
 * Consumers: any component that renders a scope level's name or a naming
 * field such as the team noun. Its only effect connects the shared
 * `parameters/analyticsLabels` store; the fallback is computed at read time
 * from the snapshot, so a missing document or a blank label shows that
 * field's default without any synced state.
 */
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import type { AnalyticsScopeLabels } from '#types';

import { analyticsScopeLabels } from './analyticsScopeLabels';
import { analyticsScopeLabelsStore } from './analyticsScopeLabelsStore';

export const useAnalyticsScopeLabels = (): Required<AnalyticsScopeLabels> => {
  useEffect(() => {
    void analyticsScopeLabelsStore.connect();
    return () => analyticsScopeLabelsStore.disconnect();
  }, []);

  const snapshot = useSnapshot(analyticsScopeLabelsStore.state);
  return analyticsScopeLabels(snapshot.data);
};
